export interface VoltagePrecariousSetpoints {
  linePhase: number
  phasePhase: number
}

const PRODIST_OVERVOLTAGE_PRECARIOUS: Record<number, VoltagePrecariousSetpoints> = {
  220: { linePhase: 135.0, phasePhase: 233.0 },
  380: { linePhase: 233.0, phasePhase: 403.0 },
}

/** Retorna os limiares "precarious" (fase-neutro e fase-fase) para a tensão nominal. */
export function resolveVoltagePrecariousSetpoints(
  nominalVoltage?: number | null,
): VoltagePrecariousSetpoints | null {
  if (nominalVoltage === null || nominalVoltage === undefined) return null

  const parsed = Number(nominalVoltage)
  if (Number.isNaN(parsed)) return null

  return PRODIST_OVERVOLTAGE_PRECARIOUS[parsed] ?? null
}
